import { node, oneOfType, shape, string } from 'prop-types';

import { Box, Link } from '@olist/united';

import { Container, Subtitle, Title } from './splash-feedback.style';

const SplashFeedbackLink = ({ link: { text, ...rest } }) => (
  <Box width="240px">
    <Link fullWidth {...rest}>
      {text || ''}
    </Link>
  </Box>
);

SplashFeedbackLink.propTypes = {
  link: shape({
    href: string,
    text: string,
  }).isRequired,
};

const SplashFeedback = ({ imgSrc, link, subtitle, title }) => (
  <Container>
    <Box mb="34px">
      <img src={imgSrc} alt={title} />
    </Box>
    <Title>{title}</Title>
    <Subtitle>{subtitle}</Subtitle>
    {link && <SplashFeedbackLink link={link} />}
  </Container>
);

SplashFeedback.defaultProps = {
  link: undefined,
};

SplashFeedback.propTypes = {
  imgSrc: string.isRequired,
  link: shape({
    href: string,
    text: string,
  }),
  subtitle: oneOfType([string, node]).isRequired,
  title: oneOfType([string, node]).isRequired,
};

export default SplashFeedback;
